// // console.log('[ETX SWIPER] Datei geladen');

window.etxDrawerSwiper = function () {
  // console.log('[ETX SWIPER] etxDrawerSwiper() wurde aufgerufen');

  // console.log('[ETX SWIPER] typeof Swiper:', typeof Swiper);

  if (typeof Swiper === 'undefined') {
    console.error('[ETX SWIPER] FEHLER: Swiper ist nicht definiert');
    return;
  }

  const sliders = document.querySelectorAll('.SwiperUpSelling');

  // console.log('[ETX SWIPER] Gefundene Slider:', sliders.length);

  if (!sliders.length) {
    console.warn('[ETX SWIPER] Keine .SwiperUpSelling Elemente gefunden');
    return;
  }

  sliders.forEach((swiperContainer, index) => {
    // console.log(`[ETX SWIPER] Slider ${index}:`, swiperContainer);

    const swiperControlId = swiperContainer.dataset.swiperId;

    // console.log(`[ETX SWIPER] Slider ${index} data-swiper-id:`, swiperControlId);

    const controlSelector =
      `.Swiper__controls[data-swiper-id="${swiperControlId}"]`;

    // console.log(`[ETX SWIPER] Suche Controls mit Selector:`, controlSelector);

    const swiperControls = document.querySelector(controlSelector);

    // console.log(`[ETX SWIPER] Controls gefunden:`, swiperControls);

    if (!swiperControls) {
      console.error(`[ETX SWIPER] FEHLER: Keine Controls für ID ${swiperControlId}`);
      return;
    }

    const prevEl = swiperControls.querySelector('.swiperArrowPrev');
    const nextEl = swiperControls.querySelector('.swiperArrowNext');

    // console.log('[ETX SWIPER] Prev Button:', prevEl);
    // console.log('[ETX SWIPER] Next Button:', nextEl);

    if (swiperContainer.swiper) {
      // console.log('[ETX SWIPER] Bestehende Swiper Instanz gefunden -> destroy',swiperContainer.swiper);

      swiperContainer.swiper.destroy(true, true);
    } else {
      // console.log('[ETX SWIPER] Keine bestehende Swiper Instanz');
    }

    try {
      // console.log('[ETX SWIPER] Initialisierung startet...');

      const swiper = new Swiper(swiperContainer, {
        spaceBetween: 20,
        loop: false,
        watchOverflow: true,
        resizeObserver: true,
        observer: true,
        observeParents: true,
        updateOnWindowResize: true,

        navigation: {
          prevEl,
          nextEl,
        },

        breakpoints: {
          0: {
            slidesPerView: 1.25,
            slidesPerGroup: 1,
          },
          400: {
            slidesPerView: 1.75,
            slidesPerGroup: 1,
          },
          560: {
            slidesPerView: 2.15,
            slidesPerGroup: 2,
          },
          768: {
            slidesPerView: 2.75,
            slidesPerGroup: 2,
          },
          1000: {
            slidesPerView: 3,
            slidesPerGroup: 3,
          }
        },

        on: {
          init(swiper) {
            // console.log('[ETX SWIPER] Swiper init Event:', swiper);
          },

          afterInit(swiper) {
            // console.log('[ETX SWIPER] Swiper afterInit Event:', swiper);
          },

          destroy(swiper) {
            // console.log('[ETX SWIPER] Swiper destroy Event:', swiper);
          },
        },
      });

      // console.log('[ETX SWIPER] ✅ Swiper erfolgreich erstellt:',swiper);

      // console.log('[ETX SWIPER] Container.swiper:',swiperContainer.swiper);
    } catch (error) {
      console.error('[ETX SWIPER] ❌ FEHLER bei new Swiper():',error);
    }
  });
};

document.addEventListener('DOMContentLoaded', () => {
  // console.log('[ETX SWIPER] DOMContentLoaded');

  // console.log( '[ETX SWIPER] DOMContentLoaded Slider vorhanden:', document.querySelector('.SwiperUpSelling'));

  window.etxDrawerSwiper();
});

// console.log('[ETX SWIPER] window.etxDrawerSwiper registriert:',typeof window.etxDrawerSwiper